<template>
  <div
    :class="(!isLoading) ? 'opacity-0 invisible' : ''"
    class="flex items-center justify-center fixed z-50 bg-opacity-75 bg-black h-full w-full top-0 left-0 flex-col duration-300 transition-all"
  >
    <p class="text-white block mb-2 font-medium">Please wait..</p>
    <pulse-loader :loading="true" :color="'#ffffff'" :size="'10px'"></pulse-loader>
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  components: {
    PulseLoader,
  },
  computed: {
    isLoading() {
      return this.$store.getters.isLoading;
    },
  },
};
</script>